/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbPortalExtensions } from "absdk/preliminary/portal/plugin/AbPortalPlugin";
export class AbPortalUserNavigationService {
  async getUserNavigation() {
    const portalSpaces = Array.from(AbPortalExtensions.PORTAL_SPACES.get().values());
    const spacesInfos = portalSpaces.map(space => {
      return {
        identifyingName: space.id,
        displayName: space.name,
        description: space.description,
        icon: space.icon,
        theme: space.theme,
        subspaceInfos: space.subspaces
      };
    });
    return {
      spaces: spacesInfos,
      navBarSpaceItems: {
        mainItems: spacesInfos.map(space => space.identifyingName),
        otherItems: []
      }
    };
  }
}
//# sourceMappingURL=AbPortalUserNavigationService.js.map
